const data = [
    {
        id: 1,
        name: "Таълим муассасаларида қишки таътил муддати узайтирилди",
        img: "https://storage.kun.uz/source/thumbnails/_medium/9/-8oMcvzj3GBrZhL0wIGtFxjg6bKH63fz_medium.jpg",
        title: "Ўзбекистонга аномал совуқ об-ҳаво кириб келиши муносабати билан барча бўғиндаги таълим муассасаларида қишки таътил муддати 17 январга қадар узайтирилди. Бу ҳақда UzA хабар бермоқда.",
        desc: `Ўқиш жараёнлари 18 январь, чоршанба кунидан бошланади. Маълумот учун, Ўзбекистонда мактаб ўқувчилари учун қишки таътил 11 январга қадар, ОТМларда эса 9 январга қадар давом этиши керак эди. Аввалроқ, “Ўзгидромет” томонидан 10-15 январь кунлари республика бўйлаб ҳаво ҳарорати кечалари 12-17 совуққача, кундуз кунлари 5-8 даража совуққача, шимолда кечалари 17-22 даража совуққача, Устюрт ва чўл ҳудудларининг баъзи жойларида кечаси 25-27, кундуз кунлари 7-10 даража совуққача пасайиши мумкинлиги маълум қилинганди.`,
        date: "19:39 / 05.01.2023",
        category: "top-big",
        tag: "#қишки таътил",
        see: "56896"
    },
    {
        id: 2,
        name: "Оптимизация сабаблари, кадрлар муаммоси, “тиши йўқ” парламент ва ишламаётган жамоатчилик назорати — экспертлар ҳукуматдаги ўзгаришлар ҳақида",
        img: "https://storage.kun.uz/source/thumbnails/_medium/9/FspOCbUODRzyiOlmlGqFkqRkRjkgBoBu_medium.jpg",
        title: "",
        date: "13:39 / 05.01.2023",
        category: "top-small",
        tag: "#Абдураҳмон Ташанов",
        see: "19880"
    },
    {
        id: 3,
        name: "Ўзбекистон бўйича аномал совуқ об-ҳаво бўлиши кутилмоқда ",
        img: "https://storage.kun.uz/source/thumbnails/_medium/9/NdjLXCAwXVkAdl6wbOfEW7UmC6QXzBMI_medium.jpg",
        title: "",
        date: "11:38 / 05.01.2023",
        category: "top-small"
    },
    {
        id: 4,
        name: "1,5 триллион сўм зарар: Парда ортидаги ишончли бошқарув оқибатлари",
        img: "https://storage.kun.uz/source/thumbnails/_medium/9/Glo6y9pyZGZmMjUU_CxDKWfzQeIXZHpP_medium.jpg",
        title: "",
        date: "08:22 / 05.01.2023",
        category: "top-small"
    },
    {
        id: 5,
        name: "Манба: Собиқ бош прокурор Рашид Қодиров шартли равишда озодликка чиқарилди",
        img: "https://storage.kun.uz/source/thumbnails/_medium/9/axupBXo7jEfFmTLIKtnAcMWLXhy4sreH_medium.jpg",
        title: "",
        date: "00:12 / 05.01.2023",
        category: "top-small"
    },
    {
        id: 6,
        name: " Россия давлат компанияларидан уруш учун фойданинг 50 фоизи олиб қўйилиши мумкин",
        img: "https://storage.kun.uz/source/thumbnails/_medium/9/axupBXo7jEfFmTLIKtnAcMWLXhy4sreH_medium.jpg",
        title: "",
        date: "14:29",
        category: "recent"
    },
    {
        id: 7,
        name: " Беларус мухолифати мамлакатда яқин орада сафарбарлик бошланишидан хавотирда",
        img: "https://storage.kun.uz/source/thumbnails/_medium/9/axupBXo7jEfFmTLIKtnAcMWLXhy4sreH_medium.jpg",
        title: "",
        date: "14:12",
        category: "recent"
    },
    {
        id: 8,
        name: " Финландия Leopard 2 жанговар танкларини Украинага топширишга тайёр",
        img: "https://storage.kun.uz/source/thumbnails/_medium/9/axupBXo7jEfFmTLIKtnAcMWLXhy4sreH_medium.jpg",
        title: "",
        date: "13:33",
        category: "recent"
    },
    {
        id: 9,
        name: " Ўзбекистон статистика портали – CИАТ ишга тушди ",
        img: "https://storage.kun.uz/source/thumbnails/_medium/9/axupBXo7jEfFmTLIKtnAcMWLXhy4sreH_medium.jpg",
        title: "",
        date: "13:33",
        category: "recent"
    },
    {
        id: 10,
        name: " Ўзбекистонда бир ойда помидор ва бодринг нархи деярли 25 фоизга ошди ",
        img: "https://storage.kun.uz/source/thumbnails/_medium/9/axupBXo7jEfFmTLIKtnAcMWLXhy4sreH_medium.jpg",
        title: "",
        date: "13:32",
        category: "recent"
    },
    {
        id: 11,
        name: " Қайси ойда энг кўп қурилиш ишлари бажарилгани маълум қилинди",
        img: "https://storage.kun.uz/source/thumbnails/_medium/9/axupBXo7jEfFmTLIKtnAcMWLXhy4sreH_medium.jpg",
        title: "",
        date: "12:53",
        category: "recent"
    }
]

export default data